<template>
  <div>
    <h1>update</h1>
    <p><img src="/imgs/logo@2x.png" alt="potly icon" width="60" height="60"></p>    
    <h2>Potly</h2>
    <div class="update">
      <button class="btn" v-on:click="doUpdate" aria-label="submit update potly apps.">アップデートする</button>
    </div>
    
    
    <article>
      <h3>リリースノート version 0.0.1</h3>
      <p>イニシャルリリース</p>
      <p>安定性に関するアップデートを行いました。</p>
    </article>
    <dl>
      <dt>Version</dt>
      <dd>0.0.1</dd>
    </dl>
    <dl>
      <dt>DB Version</dt>
      <dd>0.0.1</dd>
    </dl>
    <dl>
      <dt>Storage Info</dt>
      <dd>0.01 GB Used</dd>
    </dl>
    <p>Copyright (C) 2020 Potly Project.</p>
    <div class="full__cvr fx_ctr hcenter" v-if="updating">
      <div class="compose__pot wbox">
        <div class="compose__pot--head fx_ctr">          
          <p class="title">Updating Aps...</p>
        </div>
        <div class="compose__pot--inner">        
          <p>Please wait a moment.</p>
        </div>      
      </div>      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      updating: false
    }
  },
  methods: {
    doUpdate: async function(){
      this.updating = true;      
      window.navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        for(let registration of registrations) {
          registration.unregister();
        }
      });
      window.location.reload(true);              
    }
  }
}
</script>
<style lang="scss">
.update{
  margin: 24px auto;
  text-align: center;
}
</style>